import { render, staticRenderFns } from "./SEOScoreCard.vue?vue&type=template&id=15702dbf&scoped=true&"
import script from "./SEOScoreCard.vue?vue&type=script&lang=js&"
export * from "./SEOScoreCard.vue?vue&type=script&lang=js&"
import style0 from "./SEOScoreCard.vue?vue&type=style&index=0&id=15702dbf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15702dbf",
  null
  
)

export default component.exports